import React from 'react';
import AutolistifyLogo from '../../assets/styles/Autolistify-logo.png';
import { Box, Container, Tabs, Tab, AppBar, Toolbar, IconButton, Badge, Avatar, Menu, MenuItem } from '@mui/material';
import { ShoppingCart, Notifications, Search as SearchIcon, Store, BarChart, VpnKey, Settings, ShoppingBag, ThreeDRotation, CloudUpload, Translate, AutoAwesome } from '@mui/icons-material';

const Header = ({ activeTab, handleTabClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTabChange = (event, newValue) => {
    handleTabClick(newValue);
  };

  return (
    <AppBar position="sticky" elevation={0} sx={{ top: 0, zIndex: 1100 }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 4, minWidth: 120 }}>
            <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={AutolistifyLogo}
                alt="autolistify logo"
                style={{ height: 100, width: 'auto', display: 'block', borderRadius: 12, marginTop: 8, marginBottom: 8 }}
              />
            </a>
          </Box>

          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton size="large" color="inherit">
              <Badge badgeContent={4} color="error">
                <ShoppingCart />
              </Badge>
            </IconButton>
            <IconButton size="large" color="inherit">
              <Badge badgeContent={2} color="error">
                <Notifications />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar alt="User" src="/static/images/avatar/1.jpg" />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>Profile</MenuItem>
              <MenuItem onClick={handleClose}>My account</MenuItem>
              <MenuItem onClick={handleClose}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="main navigation tabs"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: 'primary.main',
              },
            }}
          >
            <Tab
              icon={<Store />}
              iconPosition="start"
              label="Store Connection"
              value="store-connection"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<BarChart />}
              iconPosition="start"
              label="Product Analytics"
              value="product-analytics"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<VpnKey />}
              iconPosition="start"
              label="Keyword Metrics"
              value="keyword-metrics"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<ShoppingBag />}
              iconPosition="start"
              label="Imported Products"
              value="imported-products"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<SearchIcon />}
              iconPosition="start"
              label="Taobao Search"
              value="taobao-search"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<Settings />}
              iconPosition="start"
              label="Settings"
              value="settings"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<CloudUpload />}
              iconPosition="start"
              label="Product Import"
              value="product-import"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<ThreeDRotation />}
              iconPosition="start"
              label="3D Model"
              value="3d-model"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<Translate />}
              iconPosition="start"
              label="Image Translator"
              value="image-translator"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<AutoAwesome />}
              iconPosition="start"
              label="Bulk Researcher"
              value="bulk-importer"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<AutoAwesome />}
              iconPosition="start"
              label="AI Image Gen"
              value="ai-image-gen"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<AutoAwesome />}
              iconPosition="start"
              label="Image Queue"
              value="image-queue"
              sx={{ minHeight: 64 }}
            />
          </Tabs>
        </Box>
      </Container>
    </AppBar>
  );
};

export default Header;